import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";

import Tooltip from "~/components/Tooltip";
import type { MonthlyClosingStaffingPart } from "~/modules/timeTracking/api/monthlyClosing/monthlyClosingTypes.ts";

type Props = {
	part: MonthlyClosingStaffingPart | undefined;
	onClose: () => void;
	onReopen: () => void;
};

export function ProjectCardLock({ part, onClose, onReopen }: Props) {
	const block = part?.reopen ?? part?.close;
	if (!part || !block) return null;

	// The lock follows the `reopen` block only. A Draft unlock of a closed month does not open the lock.
	const isClosed = Boolean(part.reopen);
	const Icon = isClosed ? LockClosedIcon : LockOpenIcon;
	const button = (
		<button type="button"
				aria-label={isClosed ? "Monat wieder öffnen" : "Monat schließen"}
				disabled={!block.allowed}
				className={clsx(
					"-mr-1 flex size-7 shrink-0 items-center justify-center rounded-full",
					block.allowed
						? "text-gray-500 hover:bg-gray-200 hover:text-gray-700"
						: "cursor-not-allowed text-gray-300",
				)}
				onClick={isClosed ? onReopen : onClose}>
			<Icon aria-hidden className="size-5" />
		</button>
	);

	if (block.allowed || !block.reason) return button;

	// A disabled button fires no mouse events, so the tooltip sits on a wrapper. A phone has no hover:
	// `Tooltip` opens on a tap, which reaches the wrapper.
	return (
		<Tooltip text={block.reason} width={320}>
			<span>{button}</span>
		</Tooltip>
	);
}
